import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Text } from './ui/index.jsx';

/**
 * Shared Footer Component with Legal Links
 * Used across all public pages for consistent legal compliance
 */
export default function Footer() {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="border-t border-white/5 bg-black/20 backdrop-blur-sm">
            <Container size="6xl">
                <div className="py-8">
                    {/* Main Footer Content */}
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        {/* Company Info */}
                        <div className="text-center md:text-left">
                            <Text variant="muted" size="sm">
                                © {currentYear} TheArchitect. From vague ideas to precise micro-prompts.
                            </Text>
                            <Text variant="muted" size="xs" className="mt-1">
                                Israel • <a href="mailto:support@theaiarchitect.ai" className="hover:text-white transition-colors">support@theaiarchitect.ai</a>
                            </Text>
                        </div>

                        {/* Legal Links */}
                        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 mt-4 md:mt-0">
                            <button
                                onClick={() => navigate('/terms')}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Terms of Service
                            </button>
                            <button
                                onClick={() => navigate('/privacy')}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Privacy Policy
                            </button>
                            <button
                                onClick={() => navigate('/terms#refund')}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Refund Policy
                            </button>
                            <button
                                onClick={() => navigate('/cookies')}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Cookie Policy
                            </button>
                            <button
                                onClick={() => navigate('/contact')}
                                className="text-sm text-gray-400 hover:text-white transition-colors"
                            >
                                Contact
                            </button>
                        </div>
                    </div>

                    {/* AI Disclosure - Required by Anthropic Usage Policy */}
                    <div className="mt-6 pt-4 border-t border-white/5 text-center">
                        <Text variant="muted" size="xs">
                            This platform uses AI (Claude by Anthropic) to generate content.
                            AI outputs may contain errors and should be reviewed before use.
                        </Text>
                    </div>
                </div>
            </Container>
        </footer>
    );
}
